import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
/* eslint-disable class-methods-use-this */
var hasLocalStorage = function hasLocalStorage() {
  try {
    return typeof window !== 'undefined' && window.localStorage !== undefined && window.localStorage !== null;
  } catch (error) {
    return false;
  }
};
var Storage = /*#__PURE__*/function () {
  function Storage() {
    _classCallCheck(this, Storage);
  }
  _createClass(Storage, [{
    key: "setItem",
    value: function setItem(key, value) {
      if (!hasLocalStorage()) return;
      if (value) {
        window.localStorage.setItem(key, value);
      } else {
        window.localStorage.removeItem(key);
      }
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      if (!hasLocalStorage()) return;
      window.localStorage.removeItem(key);
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      if (!hasLocalStorage()) return null;
      return window.localStorage.getItem(key);
    }
  }, {
    key: "clear",
    value: function clear() {
      if (!hasLocalStorage()) return;
      window.localStorage.clear();
    }
  }]);
  return Storage;
}();
var storage = new Storage();
export default storage;